import { Text } from '@ksyos/design-system';

export function HardwareTokenInfo() {
    return (
        <>
            <Text>Heb je de hardware token van Ksyos bij de hand?</Text>
            <img
                alt="Hardware token device"
                src="/assets/images/hardware-token-device.png"
                style={{ height: '120px', marginInline: 'auto' }}
            />
            <Text>Dan kun je het nu koppelen aan jouw account, zodat je er straks mee kunt inloggen.</Text>
        </>
    );
}
